"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.salesKeywordToRegexMap = {
    airpod: 'airpod',
    alexa: 'alexa',
    amazon: 'amazon',
    anti: 'anti',
    breach: 'breach',
    camera: 'camera',
    compromise: 'compromis',
    computer: 'computer',
    desktop: 'desktop',
    disney: 'disney',
    echo: 'echo',
    electronic: 'electronic',
    espn: 'espn',
    fake: 'fake',
    fraud: 'fraud',
    game: 'game',
    gaming: 'gaming',
    gizmo: 'gizmo',
    google: 'google',
    hacked: 'hack',
    hp: 'hp',
    hulu: 'hulu',
    icloud: 'icloud',
    infect: 'infect',
    ipad: 'ipad',
    itunes: 'itunes',
    iwatch: 'iwatch',
    laptop: 'laptop',
    macbook: 'macbook',
    mac: 'mac',
    netflix: 'netflix',
    norton: 'norton',
    pc: 'pc',
    playstation: 'playstation',
    popping: 'popping',
    printer: 'printer',
    privacy: 'privacy',
    refurbished: 'refurbish',
    ring: 'ring',
    router: 'router',
    scam: 'scam',
    scan: 'scan',
    security: 'security',
    smartwatch: 'smartwatch',
    spam: 'spam',
    speaker: 'speaker',
    spyware: 'spyware',
    steal: 'steal',
    stole: 'stole',
    streaming: 'stream',
    suspicious: 'suspicious',
    switch: 'switch',
    tablet: 'tablet',
    television: 'television',
    theft: 'theft',
    trust: 'trust',
    tv: 'tv',
    virus: 'virus',
    wireless: 'wireless',
    xbox: 'xbox',
    youtube: 'youtube',
};
const salesKeywordRegexes = Object.values(exports.salesKeywordToRegexMap);
exports.salesRegexToKeywordMap = Object.entries(exports.salesKeywordToRegexMap).reduce((map, [key, value]) => {
    const regex = salesKeywordRegexes.find((r) => value.match(r));
    if (regex) {
        map[regex] = key;
    }
    return map;
}, {});
